<template>
	<el-dialog title="新增用户" :visible.sync="dialogFormVisible" width="500px" :center="true">
        <el-form :model="formNew" :rules="rules" ref="formNew" label-width="80px" class="demo-form-inline" size="medium">
          <el-form-item label="上级用户" :label-width="formLabelWidth" prop="parent">
            <el-input v-model="formNew.parent" autocomplete="off" :disabled="true" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="用户名称" :label-width="formLabelWidth" prop="hold_name">
            <el-input v-model="formNew.hold_name" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="类型" :label-width="formLabelWidth" prop="hold_type">
            <el-select v-model="formNew.hold_type" placeholder="请选择" class="-form2-input-text">
              <el-option
                v-for="item in hold_type_options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账号" :label-width="formLabelWidth" prop="user_name">
            <el-input v-model="formNew.user_name" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="密码" :label-width="formLabelWidth" prop="user_password" v-if="displayPassword">
            <el-input v-model="formNew.user_password" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="联系人" :label-width="formLabelWidth" prop="contacts">
            <el-input v-model="formNew.contacts" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="电话" :label-width="formLabelWidth" prop="phone">
            <el-input v-model="formNew.phone" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="服务到期" :label-width="formLabelWidth" prop="vip_end_time">
              <el-date-picker
                v-model="formNew.vip_end_time"
                type="datetime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期" style="width: 300px;">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="备注" :label-width="formLabelWidth" prop="remark" v-show="displayExp">
            <el-input type="textarea" v-model="formNew.remark" class="-form2-input-text"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="SaveHoldInfo()" size="small">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Api from '../../api/index'

export default {
  name: "HoldInfoForm",
  data() {
    return {
        dialogFormVisible: false,
        formLabelWidth: '100px',
        hold_type_options: [
            {
              value: 1,
              label: '运营商'
            },{
              value: 2,
              label: '企业'
            },{
              value: 3,
              label: '部门'
            }
        ],
        displayPassword: true,
        displayExp: false,
        parent_id: 0,
        formNew: {
          hold_id: 0,
          parent: "",
          hold_name: "",
          hold_type: 2,
          user_name: "",
          user_password: "",
          contacts: "",
          phone: "",
          vip_end_time: "",
          remark: ""
        },
        rules: {
          hold_name: [
            { required: true, message: '请输入用户名称', trigger: 'blur' }
          ],
          user_name: [
            { required: true, message: '请输入账号', trigger: 'blur' }
          ],
          user_password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ]
        }
    }
  },
  methods: {
    show: function(id, parent_id) {
        this.dialogFormVisible = true;
        if(id > 0) {
          // id > 0时parent_id无参考意义
          this.displayPassword = false;
          Api.GetHoldDetail({ holdId: id }).then(res => {
            if(!res)
              return;

            if(res.code !== 200) {
              this.$message.error(res.msg);
            }

            if(res.data) {
              this.parent_id = res.data.parent_hold_id;
              this.formNew.hold_id = res.data.hold_id;
              this.formNew.parent = res.data.parent_hold_id;
              this.formNew.hold_name = res.data.hold_name;
              this.formNew.hold_type = res.data.hold_type;
              this.formNew.user_name = res.data.user_name;
              this.formNew.contacts = res.data.contacts || "";
              this.formNew.phone = res.data.phone || "";
              this.formNew.vip_end_time = res.data.vip_end_time || "";
              this.formNew.remark = res.data.remark || "";

              Api.LoadParentBase({ id: this.parent_id }).then(res => {
                if(!res && res.code !== 200)
                  return;

                if(res.data) {
                  //this.parent_id = res.data.hold_id;
                  this.formNew.parent = res.data.hold_name;
                }
              });
            }
          }).catch(err => {
              this.$message.error('错了哦，接口出错！' + err);
          });
        } else {
          this.displayPassword = true;
          this.formNew.hold_id = 0;
          this.parent_id = parent_id;

          // 获取当前日期
          const today = new Date();
          // 获取一年后的日期
          const nextYear = new Date(today);
          nextYear.setFullYear(today.getFullYear() + 3);
          this.formNew.vip_end_time = this.formatDate(nextYear); // 输出3年后的日期

          this.formNew.hold_name = "";
          this.formNew.hold_type = 2;
          this.formNew.user_name = "";
          this.formNew.user_password = "";
          this.formNew.contacts = "";
          this.formNew.phone = "";
          this.formNew.remark = "";

          Api.LoadParentBase({ id: this.parent_id }).then(res => {
            if(!res && res.code !== 200)
              return;

            if(res.data) {
              this.parent_id = res.data.hold_id;
              this.formNew.parent = res.data.hold_name;
            }
          });
        }
    },
    formatDate: function(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      
      return `${year}-${month}-${day}`;
    },
    SaveHoldInfo: function() {
      if(this.parent_id < 1) {
        this.$message.error('数据异常，无法保存！');
        return;
      }
      if(this.formNew.hold_id > 0) {
        if(this.formNew.hold_name.length === 0 ||
           this.formNew.user_name.length === 0) {
           this.$message.error('请输入用户名、账号！');
           return;
        }
      } else {
        if(this.formNew.hold_name.length === 0 ||
           this.formNew.user_name.length === 0 ||
           this.formNew.user_password.length === 0) {
          this.$message.error('请输入用户名、账号和密码！');
          return;
        }
      }
      
      var argdata = {
        hold_id: this.formNew.hold_id,
        hold_name: this.formNew.hold_name,
        hold_type: this.formNew.hold_type,
        parent_hold_id: this.parent_id,
        contacts: this.formNew.contacts,
        phone: this.formNew.phone,
        user_name: this.formNew.user_name,
        user_password: this.formNew.user_password,
        vip_end_time: this.formNew.vip_end_time,
        remark: this.formNew.remark
      };
      Api.SaveHoldInfo(argdata).then(res => {
        if(!res) {
          this.$message.error('出错了！');
          return;
        }

        if(res.code !== 200) {
          this.$message.error(res.msg);
          return;
        }

        console.log(res);

        this.$message({
          message: '恭喜你，提交成功！',
          type: 'success'
        });

        this.$emit("eventRefreshTableName");
        this.dialogFormVisible = false;
      });
    }
  }
}
</script>